import Turfmaster, { StateMachineKey, StateMachineValue } from './tmmodel';

export const USERID_FOR_SERVER_MESSAGES = 'SERVER';

export const DEBUG_USERID = '19273185-dee1-41ce-b593-634d3e3e0d8a';

// tournament config: default time span the lounge opens before a start time (in seconds)
export const TOURNAMENT_LOBBY_OPEN_DIFF_TIME = 60 * 15; // 15 minutes

export const CorsWhitelistRaw = [
  'http://localhost:8000',
  'http://127.0.0.1:8000',
  'http://localhost:8002',
  'http://127.0.0.1:8002',
  'http://web-turfmaster-e2e.localhost:1355',
  'https://web-turfmaster-e2e.localhost:1355',
  'http://localhost:5500',
  'http://localhost:9000',
  'http://localhost:63342',
  'https://web.turfmaster.localhost',
  'https://web.turfmaster.localhost:1355',
  'https://game-testing.turfmaster.de',
  'https://game-staging.turfmaster.de',
  'https://game.turfmaster.de',
];

export function stateToString(state: StateMachineValue) {
  let stateString = 'UNKNOWN';
  Object.keys(Turfmaster.stateMachine).forEach((key) => {
    if (Turfmaster.stateMachine[key as StateMachineKey] === state) {
      stateString = key;
    }
  });
  return stateString;
}

export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
